<script setup lang="ts">
import { useDisclosure, type User } from '#shared'
import { useTemplateRef } from 'vue'
import { UserProfilePreview } from '#features/user-profile-preview'
import IconAt from '#shared/ui/icons/icon-at.vue'

const { user } = defineProps<{ user: User }>()

const userProfileDisclosure = useDisclosure()
const onPingClick = () => {
  userProfileDisclosure.open()
}

const rootEl = useTemplateRef('rootEl')
</script>

<template>
  <button :class="$style.root" ref="rootEl" @click="onPingClick">
    <IconAt :class="$style.icon" />
    {{ user.displayName }}
  </button>

  <UserProfilePreview
    :isOpen="userProfileDisclosure.isOpen"
    :user="user"
    :targetEl="rootEl"
    :verticalOffset="10"
    @close="userProfileDisclosure.close"
  />
</template>

<style lang="scss" module>
@use '#mixins/button' as button;

.root {
  @include button.reset;
  display: inline-flex;
  align-items: center;
  padding: 2px 4px;
  border-radius: 4px;
  background-color: #4a8dff60;
  color: white;
  transition: background-color 0.1s;
  font-weight: 500;

  &:hover {
    background-color: #4a8dffb0;
  }
}

.icon {
  width: 16px;
  height: 16px;
}
</style>
